export default __webpack_public_path__ + "static/media/Logo.11595bcd.png";